<!--The content below is only a placeholder and can be replaced.-->
<div class="app-wrapper">
  <app-home></app-home>
</div>
<app-contact></app-contact>
<app-footer></app-footer>
